module.exports = __webpack_public_path__ + "img/mstile-310x150.e8c414d1.png";